import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import AddSiteForm from "../components/AddSiteForm";
import ErrorNotification from "../components/ErrorNotification";
import { addSite } from "../utils/api";
import { PageHeader, PageTitle, PageSubtitle } from "../components/ui";

export default function AddSite() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);

  const handleAddSiteConfirm = async (formData) => {
    try {
      await addSite(auth.user?.id_token, {
        name: formData.name,
        address: formData.address,
        lat: parseFloat(formData.lat),
        lon: parseFloat(formData.lon),
        instruction: formData.instruction,
        offering: formData.offering,
        short_term_price: formData.short_term_price !== "" ? parseFloat(formData.short_term_price) : 0.0,
        long_term_price: formData.long_term_price !== "" ? parseFloat(formData.long_term_price) : 0.0,
      });
      navigate("/sites");
    } catch (error) {
      setErrorMessage("Failed to add site: " + error.message);
      throw error;
    }
  };

  return (
    <>
      <PageHeader>
        <div>
          <PageTitle>Add a new site</PageTitle>
          <PageSubtitle>Search a place, set pricing and availability, then publish.</PageSubtitle>
        </div>
      </PageHeader>

      <AddSiteForm
        onConfirm={handleAddSiteConfirm}
        onCancel={() => navigate("/sites")}
      />

      {errorMessage && (
        <ErrorNotification
          message={errorMessage}
          duration={4000}
          onClose={() => setErrorMessage(null)}
        />
      )}
    </>
  );
}
